// Create auxiliary component to avoid React fragment import
const Auxiliary = props => props.children;

export default Auxiliary